var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('canvas',{ref:"canvas",attrs:{"id":"doughnut-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }